import { UPDATE_API_CALL_STATUS } from "../constants/ActionTypes";
import { EApiStatus, IApiCallStatusAction } from "../types/apiCallStatus.types";

export const setApiCallInProgress = (
  apiName: string,
): IApiCallStatusAction => ({
  type: UPDATE_API_CALL_STATUS,
  payload: {
    apiName,
    status: EApiStatus.IN_PROGRESS,
  },
});

export const setApiCallSuccess = (apiName: string): IApiCallStatusAction => ({
  type: UPDATE_API_CALL_STATUS,
  payload: {
    apiName,
    status: EApiStatus.SUCCESS,
  },
});

export const setApiCallError = (apiName: string): IApiCallStatusAction => ({
  type: UPDATE_API_CALL_STATUS,
  payload: {
    apiName,
    status: EApiStatus.ERROR,
  },
});
